import { useEffect, useRef } from "react";
import styled from "styled-components";
import type { ComponentProps } from "react";
import { BaseCalendar } from "../DatePicker/BaseCalendar";

//https://github.com/wojtekmaj/react-calendar
type DateRangeProps = {
  selectedDates?: Date | [Date, Date] | undefined;
  setDateRange: ComponentProps<typeof BaseCalendar>["onChange"];
  minDate: Date;
  maxDaysAhead?: number;
  allowPartialRange?: boolean;
  showDoubleView?: boolean;
};

export function DateRangeCalendar({
  selectedDates,
  setDateRange,
  minDate,
  maxDaysAhead,
  allowPartialRange = false,
  showDoubleView = false,
}: DateRangeProps) {
  const focusRef = useRef<HTMLInputElement>(null);

  // To allow focus on the calendar on render, or when the button opening the calendar was out of tab-order.
  useEffect(() => {
    if (focusRef.current !== null) {
      focusRef?.current?.focus();
    }
  }, []);

  let maxDate: Date | undefined;
  if (maxDaysAhead) {
    maxDate = new Date(minDate);
    maxDate.setDate(minDate.getDate() + maxDaysAhead);
  }

  return (
    <A11yFocusDiv ref={focusRef} tabIndex={0}>
      <BaseCalendar
        selectRange
        allowPartialRange={allowPartialRange}
        showNavigation
        minDate={minDate}
        maxDate={maxDate}
        value={selectedDates}
        onChange={setDateRange}
        showDoubleView={showDoubleView}
      />
    </A11yFocusDiv>
  );
}

const A11yFocusDiv = styled.div`
  &:focus {
    outline: none;
  }
`;
